module.exports = __webpack_public_path__ + "static/media/iconFace.eb0d5b88.svg";